<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div id="pageheader">
                <div class="row">
                    <div class="col-sm-3">
                        <span class="page-name">Activities of Map</span>
                    </div>
                    <div class="col-sm-9 text-end">
                        <form [formGroup]="filter">
                            <div class="row g-2 form-container">
                
                                <div class="col-sm-3">
                                    <ngx-select [allowClear]="true" (remove)="clearFilter('Category')" (select)="filterData()"
                                        [items]="resWorkcategory" optionValueField="Id" optionTextField="Category"
                                        formControlName="CategoryId" placeholder="Select Category">
                                    </ngx-select>
                                </div>

                                <div class="col-sm-3">
                                    <ngx-select [allowClear]="true" (remove)="clearFilter('Program')" (select)="filterData()"
                                        [items]="ProgramListArray" [disabled]="ProgramListDisabled" optionValueField="Id" optionTextField="ProgramTitle"
                                        formControlName="ProgramId" placeholder="Select Program List">
                                    </ngx-select>
                                </div>

                                <div class="col-sm-3">
                                    <ngx-select [allowClear]="true" (remove)="clearFilter('Committee')" (select)="filterData()"
                                        [items]="resCommitee" optionValueField="Id" optionTextField="BodyOrgCellName"
                                        formControlName="CommitteeId" placeholder="Select Committee">
                                    </ngx-select>
                                </div>
                                <div class="col-sm-3">
                                    <div class="input-group">
                                        <input [owlDateTime]="dt1" (dateTimeChange)="getweekRage($event.value)"
                                           class="form-control form-control-sm" [selectMode]="'range'"  formControlName="selDate" [max]="maxDate"
                                            [owlDateTimeTrigger]="dt1" placeholder="From To Date">
                                        <owl-date-time #dt1 [pickerType]="'calendar'"></owl-date-time>
                                        <button class="btn btn-light btn-sm" type="button" *ngIf="deafultShowIcon" [owlDateTimeTrigger]="dt1">
                                            <i class="fas fa-calendar-alt"></i>
                                        </button>
                                        <button class="btn btn-light border btn-sm" type="button" *ngIf="!deafultShowIcon" (click)="clearFilter('dateValue')">
                                            <i class="fas fa-times"></i></button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                
            </div>
        </div>
        
    </div>

    <div class="row chartbox mb-4">
        <div class="col-sm-12">
            <div class="card shadow-none border">
                <div class="card-body p-0">
                    <!-- [fitBounds]="true"  -->
                    <agm-map [latitude]="lat" [longitude]="lng" [zoom]='zoom' (mapReady)="onMapReady($event)" class="h-w-100" [fullscreenControl]='true'>
                        <!-- [agmFitBounds]="true"  -->
                        <agm-marker  *ngFor="let latlongData of resActivityLocation" [latitude]="latlongData.Latitude"
                            [longitude]="latlongData.Longitude"
                            (markerClick)="getBodyMemeberActivitiesDetails(latlongData?.ActvityId)">
                        </agm-marker>
                    </agm-map>
                    <!-- <img src="https://www.thestatesman.com/wp-content/uploads/2020/04/googl_ED.jpg" class="img-fluid w-100"> -->
                </div>
            </div>
        </div>
    </div>
</div>



